import React from 'react'
import { useQuery } from '@apollo/client'
import { GOAL_GROUP_CHART } from 'Apollo/Queries/GoalGroupChart'
import SignalCellularNoSimOutlinedIcon from '@mui/icons-material/SignalCellularNoSimOutlined'
import { SuperLoading } from 'Components/SharedComponents/Loading/SuperLoading'
import { useAppState } from 'Context/AppContext/AppContext'
import { GoalGroupChartSeries } from 'Generated/graphql-types'
import { FunderChartContainer } from '../FunderChart/FunderChartContainer'
import { GoalGroupChartType } from '../FunderChart/types'
import { GoalSectionEmptyState } from '../EmptyStates/GoalSectionEmptyState'
import { HeaderContainer } from './FunderGoalSections.styled'
import { EmptyStateHeaderContainer } from '../EmptyStates/FunderGoalsEmptyState.styled'

type TaskCompletionSectionProps = {
  goalGroupId: number | null
}

export const TaskCompletionSection = ({
  goalGroupId,
}: TaskCompletionSectionProps) => {
  const {
    funderOrgConfig: { orgId },
  } = useAppState()
  const { data: chartData, loading: chartLoading } = useQuery(
    GOAL_GROUP_CHART,
    {
      fetchPolicy: 'cache-and-network',
      skip: !goalGroupId,
      variables: {
        funderOrgId: orgId,
        goalGroupId,
        type: GoalGroupChartType.taskCompletion,
      },
    }
  )

  const CHART_CONTAINER_HEADER = 'Task Completion'
  const CHART_CHIP_LABEL = 'Overall Tasks Completed'
  const CHART_CHIP_TOOLTIP_TEXT =
    'This represents the total number of tasks completed across all grantees.'
  const goalGroupChartData = chartData?.goalGroupChart
  const chartType = GoalGroupChartType.taskCompletion
  const isChartSeriesEmpty = !chartData?.goalGroupChart?.seriesData.some(
    (chart: GoalGroupChartSeries) => chart.data.length > 0
  )

  if (chartLoading) return <SuperLoading />
  if ((!chartData || isChartSeriesEmpty) && !chartLoading) {
    return (
      <EmptyStateHeaderContainer>
        <HeaderContainer>Task Completion</HeaderContainer>
        <GoalSectionEmptyState
          icon={<SignalCellularNoSimOutlinedIcon />}
          headerText='No Completed Tasks'
          subheaderText='This chart will show the number of tasks Grantees have completed overtime.'
        />
      </EmptyStateHeaderContainer>
    )
  }

  return (
    <FunderChartContainer
      chartContainerHeader={CHART_CONTAINER_HEADER}
      chartChipText={CHART_CHIP_LABEL}
      chartTooltipText={CHART_CHIP_TOOLTIP_TEXT}
      chartData={goalGroupChartData}
      chartType={chartType}
      goalGroupId={goalGroupId}
      loading={chartLoading}
    />
  )
}
